// Curated real-world kitesurf gear brands for autocomplete suggestions.
// Users can always type a custom brand not in these lists.

export const KITE_BRANDS = [
  'Duotone', 'North', 'Cabrinha', 'F-One', 'Core', 'Ozone', 'Naish', 'Slingshot',
  'Airush', 'Eleveight', 'Reedin', 'Flysurfer', 'Harlem', 'RRD', 'Liquid Force',
  'CrazyFly', 'Gin Kiteboarding', 'Peter Lynn', 'Best Kiteboarding', 'Switch Kites',
  'Gaastra', 'Concept Air', 'Nobile', "O'Shea", 'Brunotti', 'Vegas',
];

export const BOARD_BRANDS = [
  'North', 'Duotone', 'CrazyFly', 'Nobile', 'Shinn', 'Appletree', 'Lieuwe', 'Airush',
  'Cabrinha', 'F-One', 'Core', 'Naish', 'Slingshot', 'Liquid Force', 'RRD', 'Goodboards',
  'Brunotti', "O'Shea", 'Flysurfer', 'Ozone', 'Spleene', 'Underground',
];

export const ACCESSORY_BRANDS = [
  'Mystic', 'ION', 'Manera', 'Prolimit', 'Dakine', 'Ride Engine', 'Sooruz', 'Duotone',
  'Core', 'Cabrinha', 'North', 'Naish', "O'Neill", 'Xcel', 'Brunotti',
];

export const FOIL_BRANDS = [
  'F-One', 'Cabrinha', 'Duotone', 'North', 'Core', 'Naish', 'Slingshot', 'Armstrong',
  'Axis', 'Gong', 'Moses', 'Sabfoil', 'Levitaz', 'Mike’s Lab', 'Takuma',
];

export const GEAR_TYPES = [
  { key: 'kite', label: 'Kite' },
  { key: 'board', label: 'Board' },
  { key: 'bar', label: 'Bar' },
  { key: 'harness', label: 'Harness' },
  { key: 'wetsuit', label: 'Wetsuit' },
  { key: 'foil', label: 'Foil' },
];

export function brandsForType(type) {
  switch (type) {
    case 'kite': return KITE_BRANDS;
    case 'board': return BOARD_BRANDS;
    case 'foil': return FOIL_BRANDS;
    case 'bar':
    case 'harness':
    case 'wetsuit': return ACCESSORY_BRANDS;
    default: return [...new Set([...KITE_BRANDS, ...BOARD_BRANDS])].sort();
  }
}

export function sizePlaceholder(type) {
  switch (type) {
    case 'kite': return 'e.g. 9m';
    case 'board': return 'e.g. 138cm';
    case 'wetsuit': return 'e.g. 5/4';
    case 'foil': return 'e.g. 1200cm²';
    case 'bar': return 'e.g. 22m';
    default: return 'Size';
  }
}
